import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 99;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, memo } from "react";
import { useTheme as useNextTheme } from "next-themes";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "@pancakeswap/localization";
import BottomNavItem from "../BottomNavItem";
import StyledBottomNav from "./styles";
import { Box } from "../Box";
import { Text } from "../Text";
import { ThemeSwitcher } from "../ThemeSwitcher";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import { NotificationDot } from "../NotificationDot";
import { Overlay } from "../Overlay";
import LangSelector from "../LangSelector/LangSelector";
import { CloseMenuIcon } from "../Svg";
import { useMatchBreakpoints } from "../../contexts";
var FlexWapper = styled(Box).withConfig({
    componentId: "sc-963278d5-0"
})(_templateObject());
var CloseWrapper = styled(Box).withConfig({
    componentId: "sc-963278d5-1"
})(_templateObject1());
var BottomNav = function(_param) {
    var _items = _param.items, items = _items === void 0 ? [] : _items, _activeItem = _param.activeItem, activeItem = _activeItem === void 0 ? "" : _activeItem, _activeSubItem = _param.activeSubItem, activeSubItem = _activeSubItem === void 0 ? "" : _activeSubItem, isUnmounting = _param.isUnmounting, currentLang = _param.currentLang, setLang = _param.setLang, langs = _param.langs, onClose = _param.onClose, props = _object_without_properties(_param, [
        "items",
        "activeItem",
        "activeSubItem",
        "isUnmounting",
        "currentLang",
        "setLang",
        "langs",
        "onClose"
    ]);
    var setTheme = useNextTheme().setTheme;
    var isDark = useTheme().isDark;
    var t = useTranslation().t;
    var isMobile = useMatchBreakpoints().isMobile;
    var ref = useState({}), menuOpenByIndex = ref[0], setMenuOpenByIndex = ref[1];
    var isBottomMenuOpen = Object.values(menuOpenByIndex).some(function(acc) {
        return acc;
    });
    console.log("isBottomMenuOpen=========", isBottomMenuOpen, activeItem, isUnmounting);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Overlay, {
                isUnmounting: !isUnmounting
            }),
            /*#__PURE__*/ _jsx(CloseWrapper, {
                onClick: function() {
                    console.log("isUnmounting", isUnmounting);
                    onClose();
                    window.localStorage.removeItem("isShowPopup");
                },
                children: /*#__PURE__*/ _jsx(CloseMenuIcon, {
                    width: "16px"
                })
            }),
            /*#__PURE__*/ _jsxs(StyledBottomNav, _object_spread_props(_object_spread({
                flexDirection: "column"
            }, props), {
                children: [
                    items.map(function(param, index) {
                        var label = param.label, menuItems = param.items, href = param.href, _showOnMobile = param.showOnMobile, showOnMobile = _showOnMobile === void 0 ? true : _showOnMobile, _showItemsOnMobile = param.showItemsOnMobile, showItemsOnMobile = _showItemsOnMobile === void 0 ? true : _showItemsOnMobile, disabled = param.disabled;
                        var ref, ref1;
                        var statusColor = (ref = menuItems === null || menuItems === void 0 ? void 0 : menuItems.find(function(menuItem) {
                            return menuItem.status !== undefined;
                        })) === null || ref === void 0 ? void 0 : (ref1 = ref.status) === null || ref1 === void 0 ? void 0 : ref1.color;
                        return showOnMobile && /*#__PURE__*/ _jsx(DropdownMenu, {
                            items: menuItems,
                            isBottomNav: true,
                            activeItem: activeSubItem,
                            showItemsOnMobile: showItemsOnMobile,
                            setMenuOpenByIndex: setMenuOpenByIndex,
                            index: index,
                            isDisabled: disabled,
                            children: /*#__PURE__*/ _jsx(Box, {
                                children: /*#__PURE__*/ _jsx(NotificationDot, {
                                    show: !!statusColor,
                                    color: statusColor,
                                    children: /*#__PURE__*/ _jsx(BottomNavItem, {
                                        href: href,
                                        disabled: disabled,
                                        isActive: href === activeItem,
                                        label: label,
                                        isBottomMenuOpen: isBottomMenuOpen,
                                        showItemsOnMobile: showItemsOnMobile
                                    })
                                })
                            })
                        }, "".concat(label, "#").concat(href));
                    }),
                    /*#__PURE__*/ _jsxs(FlexWapper, {
                        mt: "10px",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                color: "textMenuMobile",
                                children: t("Theme")
                            }),
                            /*#__PURE__*/ _jsx(ThemeSwitcher, {
                                isDark: isDark,
                                toggleTheme: function() {
                                    return setTheme(isDark ? "light" : "dark");
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(FlexWapper, {
                        mt: "10px",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                color: "textMenuMobile",
                                children: t("Language")
                            }),
                            /*#__PURE__*/ _jsx(LangSelector, {
                                currentLang: currentLang,
                                langs: langs,
                                setLang: setLang,
                                buttonScale: "xs",
                                color: "textSubtle",
                                isMobile: isMobile
                            })
                        ]
                    })
                ]
            }))
        ]
    });
};
export default /*#__PURE__*/ memo(BottomNav);
